import { render, staticRenderFns } from "./RecomendationsModal.vue?vue&type=template&id=5e8b0ddd&scoped=true"
import script from "./RecomendationsModal.vue?vue&type=script&lang=js"
export * from "./RecomendationsModal.vue?vue&type=script&lang=js"
import style0 from "./RecomendationsModal.vue?vue&type=style&index=0&id=5e8b0ddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8b0ddd",
  null
  
)

export default component.exports